import { server } from '@/infra/server'
import { CessTokenParam } from './acManager.controller'

export type SendEmailOwnershipVerificationParams = {
  email: string
  recipientFullName: string
  logoLink: string
  isPartner: boolean
  recipientIdentity: string
  cessToken: CessTokenParam
  subjectPrefix?: string
  callbackUrl?: string
  sendOtpOption?: string
}

export type SendEmailOwnershipVerificationResponse = {
  otp_prefix: string
}

export type ValidateEmailOwnershipOtpParams = {
  otp: string
  cessToken: CessTokenParam
}

export type ValidateEmailOwnershipOtpResponse = {
  success: boolean
}

const msValidationController = {
  sendEmailOwnershipVerification: (
    params: SendEmailOwnershipVerificationParams,
  ) =>
    server.post<SendEmailOwnershipVerificationResponse>(
      'send-email-ownership-verification',
      params,
    ),
  validateEmailOwnershipOtp: (params: ValidateEmailOwnershipOtpParams) =>
    server.post<ValidateEmailOwnershipOtpResponse>(
      'validate-email-ownership-otp',
      params,
    ),
}

export default msValidationController
